// extracted by css-extract-rspack-plugin
export default {"q_panel":"mqWuFI7if1IzED89","q_description":"OcYvK46QQ3gVV_io","text_center":"b7exqLexJYH54Ymw"};